// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReactModal__Content {
    background: var(--body-background-color);
    color: var(--default-text-color);
}

h2 {
    font-weight: 600;
    text-align: center;
    font-size: 1.5rem;
}

.help-modal {
    font-family: var(--main-font);
    font-size: 1rem;
}

.help-modal ul {
    padding-inline-start: 1rem;
}

.help-modal ul ol {
  list-style-type: lower-alpha; /* Sub-list uses letters */
  padding-inline-start: 2rem; /* Adjust indentation for sub-list */
}

.help-modal h2 {
    margin-top: 0;
}

.help-modal li {
    margin-bottom: 0.75rem;
}

.help-modal h4,h3, label {
    font-size: 1.1rem;
    font-weight: 550;
}

.help-modal code {
    font-family: monospace;
}

.help-modal .example-container {
    flex-direction: row;
    display: flex;
    justify-content: space-around;
    gap: 1rem;
    box-sizing: border-box;
}

.help-modal .example-triplit {
    text-align: center;
    margin-bottom: 0;
}

.help-modal .example-container h4 {
    margin: 1rem;
}

.help-modal .feedback-example {
    width: 200px;
}

.inline-square {
    display: inline-block;
    vertical-align: baseline;
    width: 10px;
    aspect-ratio: 1.0;
}

.example-blue {
    color: #2196f3;
}

.example-green {
    color: #4caf50;
}

.example-red {
    color: #9c27b0;
}

.emphasized {
    font-weight: 600;
}

.victory-modal-container {
    font-family: var(--main-font);
    font-size: 1.25rem;
    text-align: center;
    overflow-y: scroll;
    overflow-x: hidden;
    margin: 0 10px;
}

.victory-modal-container h2 {
    font-size: 2rem;
    font-weight: 590;
    margin-top: 0.75rem;
    margin-bottom: 0.75rem;
}

.victory-modal-container .percentile-text {
    font-size: 0.9rem;
}

.victory-modal-container .score-explanation-icon {
    width: 1rem;
    fill: rgb(125, 125, 125);
}

.victory-modal-container .medal-img {
    width: 75%;
    height: auto;
}


.victory-modal-container h3 {
    text-align: start;
    margin-bottom: 0.75rem;
}

.victory-modal-container .statistics-section {
    font-size: 1rem;
}

.victory-modal-container .statistics-section tr:nth-child(1) {
    font-weight: 600;
    font-size: 1.2rem;
}

.victory-buttons-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 1.25rem;
    margin-bottom: 0.8rem;
    justify-content: center;
    gap: 0.4rem;
}

.game-button.victory-button {
    font-size: 1.2rem;
    font-weight: 600;
    flex-direction: row;
    width: 75%;
    padding: 0.5rem 0;
    gap: 0.25rem;
    border-radius: 10px;
}

td.statistics-container {
    vertical-align: center;
}

.game-button {
    display: flex;
    flex: 1;
    flex-direction: column;
    border-radius: 10px;
    color: white;
    fill: white;
    border: 0px;
    font-size: 1.1rem;
    font-family: var(--main-font);
    justify-content: center;
    align-items: center;
    background-color: var(--victory-modal-gray);
}

button.button-secondary {
    background-color: white;
    outline: 1px solid black;
    color: black;
}

.share-button-default {
    background-color: var(--victory-modal-gray);
}

td.statistics-container {
    width: 5%;
    min-width: 3rem;
}

.no-break {
    white-space: nowrap;
}

.tutorial-exit-button {
    top: 0;
    position: absolute;
    left: 0rem;
    margin: 0.5rem;
    fill: rgb(150, 150, 150);
}

.turn-indicator-container {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: calc(var(--turn-indicator-width) * 0.3);
    margin: 0.75rem var(--turn-indicator-width)
}

.turn-indicator {
    width: var(--turn-indicator-width);
    box-sizing: border-box;
    aspect-ratio: 1.0;
    border: 1px solid rgb(200, 200, 200);
    background-color: rgb(200, 200, 200);
    border-radius: 50%;
    transition: background-color var(--turn-transition-duration) linear;
}

.turn-indicator.turn-indicator-empty {
    background-color: transparent;
}

.special-modal-container {
    font-family: var(--main-font);
    font-size: 1.25rem;
    text-align: center;
    overflow-y: scroll;
    overflow-x: hidden;
    margin: 0 10px;
    height: fit-content;
}


@keyframes shakeHeadNo {
    0% {
        transform: translateX(0);
    }

    25% {
        transform: translateX(-1.2rem);
    }

    50% {
        transform: translateX(0);
    }

    75% {
        transform: translateX(1.2rem);
    }

    100% {
        transform: translateX(0);
    }
}

@keyframes victoryAnimation {
    0% {
        transform: scale(1);
    }

    7% {
        transform: scale(1.10);
    }

    14% {
        transform: scale(1.05);
    }

    21% {
        transform: scale(1.10);
    }

    60% {
        transform: scale(1.10);
    }

    100% {
        transform: scale(1);
    }
}

.victory-animation {
    display: inline-block;
    animation: victoryAnimation 1s linear;
}

.center-text {
    text-align: center;
}
a.game-link {
    text-decoration: none;
    color: inherit;
}

.banner-top {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: var(--banner-height);
    box-shadow: 0px 2px 4px var(--banner-shadow-color);
    /* border-bottom: 1px solid lightgray; */

}

html[data-theme='dark'] .banner-top {
    box-shadow: 0px 2px 2px var(--banner-shadow-color);
}

.outer-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    font-size: 1.5rem;
    font-family: var(--main-font);
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
}

.inner-container {
    display: flex;
    width: 100%;
    height: calc(100% - var(--banner-height));
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    overflow: hidden;
    position: relative;
}

.game-title {
    font-size: 2rem;
    font-family: var(--main-font);
    color: var(--default-text-color);
    margin-left: 0.5rem;
    font-weight: 500;
}

.menu-buttons-container {
    margin-right: 0.5rem;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 100%;
    gap: 0.25rem;
    fill: rgb(100, 100, 100);
}

.menu-buttons-container svg {
    height: 50%;
    width: auto;
    fill: var(--default-text-color);
}

.game-container {
    font-size: 1.5rem;
    width: 100%;
    min-width: 10rem;
    max-width: var(--max-width);
    font-family: var(--main-font);
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 3 1 70%;
    min-height: 0;
    overflow-x: hidden;
    overflow-y: scroll;
    justify-content: space-around;
}

.game-container {
    -ms-overflow-style: none;  /* Internet Explorer 10+ */
    scrollbar-width: none;  /* Firefox */
}

/* Hide scrollbar for Chrome, Safari and Opera */
.game-container::-webkit-scrollbar {
    display: none;
}

.guess-row {
    display: flex;
    flex-direction: row;
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: 0;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin: 0 auto;
}

.guess-row:nth-of-type(1) {
    width: 37.5%
}

.guess-row:nth-of-type(2) {
    width: 50%
}

.guess-row:nth-of-type(3) {
    width: 62.5%;
}

.guess-row:nth-of-type(4) {
    width: 75%;
}

.control-row {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 2rem;
}

.input-box {
    text-transform: uppercase;
    width: 1rem;
    height: 1rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 50cqw;
}

.input-box.filled-in-by-user {
    color: var(--default-text-color);
}

.input-box.input-failed {
    color: var(--default-text-color);
}

.input-box.input-incorrect {
    color: var(--incorrect-color);
    transition: color 500ms linear;
}

.input-box.triplet-box {
    color: var(--default-text-color);
}

.input-container.triplet-letter-container {
    outline: none;
    font-weight: 600;
    -webkit-tap-highlight-color: transparent;  /* For Safari and Chrome */
    tap-highlight-color: transparent;          /* Standard */
}

.input-container.triplet-letter-container.triplet-blur {
    visibility: hidden;
}

@keyframes fadeIn {
    0% {
        opacity: 0;
        /* Starting state */
    }

    100% {
        opacity: 1;
        /* Ending state */
    }
}

@keyframes fadeOut {
    0% {
        opacity: 1;
        /* Starting state */
    }

    100% {
        opacity: 0;
        /* Ending state */
    }
}

.fade-out {
    opacity: 1;
    /* Start invisible */
    animation: fadeOut 1s ease-in forwards;
    /* Apply animation */

}

.fade-in {
    opacity: 0;
    /* Start invisible */
    animation: fadeIn 1s ease-in forwards;
    /* Apply animation */
}

.input-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    outline: 2px solid var(--cell-outline-color);
    aspect-ratio: 1;
    container-type: inline-size;
    flex: 0 1 auto;
    width: 18vmin;
    max-width: 5rem;
    margin: calc(var(--letter-margin-rem) * 1rem);
    font-weight: 600;
    transition: color var(--half-turn-transition-duration) var(--half-turn-transition-duration) linear, background-color var(--turn-transition-duration) linear;
}

.tile-verified {
    background-color: var(--verified-blue);
    outline-color: var(--verified-blue);
    color: var(--verified-text-color);
}

.game-button.first-turn, .histogram-bar.first-turn, .first-turn {
    background-color: var(--first-turn-color);
}
.first-turn-outline {
    outline-color: var(--first-turn-color);
}
.clue-checkmark-container.first-turn-fill, .first-turn-fill {
    fill: var(--first-turn-color);
}
.first-turn-border {
    border-color: var(--first-turn-color);
}

.game-button.second-turn, .histogram-bar.second-turn, .second-turn {
    background-color: var(--second-turn-color);
}
.second-turn-outline {
    outline-color: var(--second-turn-color);
}
.clue-checkmark-container.second-turn-fill, .second-turn-fill {
    fill: var(--second-turn-color);
}
.second-turn-border {
    border-color: var(--second-turn-color);
}

.game-button.third-turn, .histogram-bar.third-turn, .third-turn {
    background-color: var(--third-turn-color);
}
.third-turn-outline {
    outline-color: var(--third-turn-color);
}
.clue-checkmark-container.third-turn-fill, .third-turn-fill {
    fill: var(--third-turn-color);
}
.third-turn-border {
    border-color: var(--third-turn-color);
}

.game-button.fourth-turn, .histogram-bar.fourth-turn, .fourth-turn {
    background-color: var(--fourth-turn-color);
}
.fourth-turn-outline {
    outline-color: var(--fourth-turn-color);
}
.clue-checkmark-container.fourth-turn-fill, .fourth-turn-fill {
    fill: var(--fourth-turn-color);
}
.fourth-turn-border {
    border-color: var(--fourth-turn-color);
}

button.fifth-turn, .histogram-bar.fifth-turn, .fifth-turn {

    background-color: var(--fifth-turn-color);
}
.fifth-turn-outline {
    outline-color: var(--fifth-turn-color);
}
.clue-checkmark-container.fifth-turn-fill, .fifth-turn-fill {
    fill: var(--fifth-turn-color);
}
.fifth-turn-border {
    border-color: var(--fifth-turn-color);
}

.clue-checkmark-container {
    display: contents;
    fill: var(--verified-blue);
}

.clue-checkmark-container.clue-checkmark-hidden {
    opacity: 0;
}

.clue-checkmark {
    opacity: inherit;
    fill: inherit;
    transform: translateY(5%);
    transition: opacity calc(var(--turn-transition-duration)) 0.1s linear;
    width: max(0.5rem, min(min(5.2cqw, 3.5cqh), 1.8rem));
    display: block;
    flex: 0 0 auto;
}

.outer-clue-container {
    flex: 0 1 auto;
    width: 100%;
}

.clue-reminder .clue-container {
    font-size: 2.5vh;
    text-wrap: balance;
}

.clue-container {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    width: 100%;
    font-size: clamp(0.5rem, min(5.2cqw, 3.5cqh), 1.8rem);
    container-type: inline-size;
    height: min(20vmin, 15vh);
    font-family: var(--title-font);
    overflow-y: scroll;
    gap: 0.25rem;
}

.reminder-middle {
    font-style: italic;
}

.clue-container {
    -ms-overflow-style: none;  /* Internet Explorer 10+ */
    scrollbar-width: none;  /* Firefox */
}

/* Hide scrollbar for Chrome, Safari and Opera */
.clue-container::-webkit-scrollbar {
    display: none;
}

.clue-container.clue-container-no-checkmark {
    gap: 0;
}


@media screen and (max-height: 650px) {
    .input-container {
        width: 8vh;
    }
}

.guesses-container {
    display: flex;
    flex-direction: column;
    flex: 0 1 auto;
    max-width: 45rem;
}

.first-row-no-triplit {
    margin-top: 4vh;
}

.input-container.selected { 
    outline: 2px solid var(--selected-color);
}

.timer-container {
    overflow: visible;
    margin: 0 0.5rem;
    text-align: left;
}

.timer {
    font-size: 1.25rem;
    font-weight: 500;
    margin-top: 0.1rem;
    margin-right: 0.1rem;
}

.banner-icon-container {
    display: flex;
}

.banner-icon {
    fill: var(--default-text-color);
}

.streak-container {
    display: flex;
    flex-direction: row;
    font-size: 1.4rem;
    align-items: center;
    font-weight: 600;
    color: rgb(var(--streak-color));
}

.menu-buttons-container .streak-container .flame-icon {
    fill: rgb(var(--streak-color));
}

.streak-text {
    font-weight: 600;
    color: rgb(var(--streak-color));
}

.flame-icon {
    margin-left: -0.1rem;
}

#help-icon {
    width: 1.5rem;
    height: 1.5rem;
}

.hamburger-menu-container {
    font-family: var(--main-font);
    font-size: 1.2rem;
}

.hamburger-menu-item a {
    text-decoration: none;;
    color: var(--default-text-color);
}

.hamburger-menu-item:not(:last-child) {
    border-bottom: 1px solid var(--default-text-color);
}

.hamburger-menu-item {
    padding-top: 0.4rem;
    padding-bottom: 0.4rem;
    padding-left: 0.4rem;
    padding-right: 0.4rem;
}

.date-selector-modal-container {
    font-family: var(--main-font);
    font-size: 1.25rem;
    margin: 0.5rem;
}

.settings-modal-container {
    font-family: var(--main-font);
    font-size: 1.25rem;
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
}

.settings-modal-container * {
    margin-top: 0;
    margin-bottom: 0;
}

.settings-section {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.notification-time-label {
    font-size: 1rem;

}

.settings-modal-container .notification-time-input {
    border-width: 1px;
}

.settings-modal-container table {
    width: 100%;
    border-collapse: collapse;
}

.settings-modal-container h2 {
    text-align: center;
    font-size: 1.5rem;
}

.settings-modal-container tr:not(:last-child) td {
    padding-bottom: 0.5rem;
}

.settings-modal-container td:nth-child(1) {
    text-align: left;
    padding-left: 1.5rem;
}

.settings-modal-container td:nth-child(2) {
    text-align: right;
    padding-right: 1.5rem;
}

.settings-modal-container b {
    font-weight: 600;

}

.settings-modal-container h2 {
    font-weight: 600;
}

.settings-modal-container input {
    -webkit-tap-highlight-color: transparent;
}


.timer-setting-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.timer-slider-container {
    height: 1.5rem;
}

.timer-slider {
    width: 100%;
}

.timer-setting-label {
    font-size: 1rem;
    text-align: center;
    height: 0;
}

.adjustment-text {
    font-size: 1rem;
    margin-top: 0.75rem;
}

.adjustment-text-link {
    text-decoration: underline;
    cursor: pointer;
}

.difficulty-list {
    font-size: 1rem;
    padding: 0;
}

.difficulty-settings-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: auto;
    width: 85%;
}

.difficulty-setting-container {
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
}

.difficulty-setting-container input[type="radio"] {
    box-sizing: border-box;
    appearance: none;
    background: white;
    outline: 1px solid #333;
    border: 3px solid white;
    border-radius: 0;
    width: 1.25rem;
    height: 1.25rem;
}

.difficulty-setting-container input[type="radio"]:checked {
    background-color: var(--selection-blue);
}

.difficulty-setting-container label {
    font-size: 1.1rem;
}

.settings-modal-container ul {
    list-style-position: inside;
}

.difficulty-slider {
    width: 100%;
}

.difficulty-slider-labels {
    display: flex;
    justify-content: space-between;
}

.difficulty-slider-label-container {
    margin-top:0.5rem;
    width:0;
    overflow: visible;
}

.difficulty-slider-label {
    transform: translateX(-50%);
    width: fit-content;
    font-size: 1rem;
}

.setting-explanation {
    font-size: 1rem;
    color: rgb(75, 75, 75);
}

.keyboard-container {
    flex: 1 0 30%;
    max-height: 13rem;
    font-size: 1.25rem;
    width: 100%;
    max-width: var(--max-width);
    left: 0;
    right: 0;
}

.keyboard-container .hg-theme-default .hg-button {
    border-bottom: none;
    box-shadow: none;
    background: var(--default-button-background-color);
    color: var(--default-button-text-color);
}

.keyboard-container .react-simple-keyboard {
    width: 100%;
    height: 100%;
    max-height: 15rem;
    background-color: initial;
    font-weight: 500;
}

.keyboard-container .react-simple-keyboard .hg-rows {
    display: flex;
    flex-direction: column;
    height: 100%;
}

.keyboard-container .react-simple-keyboard .hg-rows .hg-row {
    flex-grow: 1;
}

.control-row {
    fill: rgb(100, 100, 100);
    color: rgb(100, 100, 100);
    width: 100%;
    container-type: inline-size;
    height: calc(3.5rem + 4vh);
    max-height: 5rem;
    flex: 0 1 auto;
}

.control-row button {
    width: 7.5rem;
    height: 60%;
    color: var(--default-text-color);
    flex: 0 0 auto;
    border-radius: 10cqw;
    font-weight: 500;
}


.control-row button.action-button {
    background-color: var(--default-button-background-color);
    color: var(--default-button-text-color);
}

.control-row .icon {
    height: 50%;
    width: auto;
    fill: inherit;
    flex: 0 0 auto;
}

.control-row button:disabled {
    filter: opacity(0.3);
}

.control-row svg.icon path {
    stroke-width: 1px;
}


/** Note that all of the CSS rules related to the keyboard must be highly
  * sepcified in order to have higher precedence than the rules built into
  * the default theme of the simple-keyboard library. */

.keyboard-container .custom-keyboard-theme {
    font-family: var(--main-font);
    text-transform: capitalize;
}

.keyboard-container .custom-keyboard-theme .hg-button {
    height: 100%;
}

.keyboard-container .custom-keyboard-theme .hg-button.hg-standardBtn {
    width: 8.5%;
    flex-grow: 0;
}   

.keyboard-container .custom-keyboard-theme .hg-button.hg-functionBtn {
    width: 13%;
    flex-grow: 0;
}   

.keyboard-container .custom-keyboard-theme .hg-button.hg-button-backspace {
    width: 13%;
    font-family: system-ui;
}   

.keyboard-container .custom-keyboard-theme .hg-button.hg-button-clear,
.keyboard-container .custom-keyboard-theme .hg-button.hg-button-enter {
    font-size: 0.8rem;
}   


.keyboard-container .custom-keyboard-theme .hg-row {
    justify-content: center;
}

.mobile-landscape-warning-container {
    display: none;
}

/* There is no way to specifically query for mobile devices - there are only proxies.
    For now we will use the height of the viewport and the orientation to detect if a user
    is on a mobile device using portrait mode. When the orientation lock API is more widely
    supported, we can use that instead. For now this query will also pick up users on
    desktops/laptops who have their browser window very small and wide. This seems
    acceptable for now. */
@media only screen and (max-height: 480px) and (orientation: landscape) {
    .mobile-landscape-warning-container {
        display: flex;
        position: fixed;
        height: 100%;
        width: 100%;
        justify-content: center;
        align-items: center;
        opacity: 1;
        background-color: var(--body-background-color);
    }
}

.banner-popup {
    position: absolute;
    margin: 0 auto;
    top: 0.5%;
    max-width: min(var(--max-width), 80%);
    height: fit-content;
    background-color: #4f4f4f;
    color: white;
    opacity: 95%;
    padding: 1rem;
    border-radius: 0.5rem;
    font-size: 1.1rem;
    font-weight: 500;
    text-align: center;
    z-index: 10000;
}

.gameplay-video {
    width: 90%;
    height: auto;
    max-width: 375px;
    margin: 0 auto;
    display: block;
}

.gameplay-video-container {
    margin: 0 auto;
    width: fit-content;
}

.congrats-header {
    font-size: 1.25rem;
}

.play-button-container {
    margin: 0 auto;
    width: fit-content;
}

.play-button {
    height: 3rem;
    width: 4rem;
    border-radius: 2rem;
    background-color: var(--first-turn-color);
    font-weight: 600;
}

.examples-modal table {
    border-collapse: collapse;
}

.examples-modal {
    font-size: 0.9rem;
}

.examples-modal td {
    vertical-align: top;
    padding: 0.5rem;

}

.examples-modal td {
    vertical-align: top;
    padding: 0.5rem;

}

.examples-modal h3 {
    margin-top: 0.125rem;
}

.examples-modal tbody>tr:nth-of-type(odd) {
    background-color: var(--lighter-table-row-color);
}

.examples-modal td, .examples-modal th {
    padding: 0.5rem 0.25rem;
    text-align: left;
}

.wordplay-modal {
    font-size: 0.9rem;
}

.disconnected-icon {
    display: block;
    margin: 0 auto;
    padding: 20px;
    width: 60px;
    height: auto;
    fill: var(--default-text-color);
}

.bonus-puzzles-modal-container {
    text-align: center;
    font-size: 1.1rem;
}

.bonus-puzzles-container {
    display: flex;
    flex-direction: row;
    gap: 0.5rem;
    flex-wrap: wrap;
    justify-content: center;
    width: 80%;
    margin: 0 auto;
}

.bonus-puzzle-cell {
    width: 1rem;
    padding: 0.4rem;
    outline: 1px solid var(--cell-outline-color);
    flex: 0 0 auto;
    display: flex;
    justify-content: center;
    position: relative;
    border-radius: 2px;
}

.bonus-puzzle-cell.bonus-locked {
    background-color: lightgray;
    color: rgb(125, 125, 125);
}

/*
.bonus-locked::after {
    content: "🔒";
    position: absolute;
    font-size: 0.5rem;
    color: lightgray;
    top: -0.5px;
    right: -0.5px;
}
    */

.bonus-puzzles-modal-container h2 {
    text-align: center;
}

.bonus-puzzles-modal-container .lock-icon {
    position: absolute;
    top: 0;
    right: 0;
    width: 0.5rem;
}

.bonus-puzzle-unseen::after {
    content: "";
    background-color: #3d88ed; 
    position: absolute;
    display: block;
    right: 2px;
    top: 2px;
    width: 7px;
    aspect-ratio: 1.0;
    border-radius: 50%;
}

.bonus-selected {
    background-color: var(--selected-puzzle-color);
}

.present-icon {
    position: relative;
}

.present-icon-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
}

.present-icon-container.unseen-bonus::after {
    outline: 2px solid var(--default-text-color);
    width: 2px;
    aspect-ratio: 1.0;
    content: "";
    position: absolute;
    display: block;
    right: 1.5px;
    top: -1.5px;
    /* border-radius: 6px; */
    transform: rotate(45deg);
}

.svg-as-text {
    fill: white;
    vertical-align: text-bottom;
}

.learning-style-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
}

.learning-style-button {
    height: 3rem;
    width: 6rem;
    flex: 0 1 auto;
    background-color: var(--start-button-color);
    border-radius: 1rem;
    font-weight: 700;
    font-size: 1.3rem;
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 0.3rem;
    border: 4px solid var(--default-text-color);
    color: var(--default-text-color);
}

.learning-style-button:hover {
    background-color: lightgray;
}

.welcome-description-container {
    width: fit-content;
    margin-left: auto;
    margin-right: auto;
    font-size: 1.3rem;
}

.welcome-description {
    text-align: center;
    display: inline-grid;
    grid-template-columns: auto auto auto;
    margin-left: 5px;
  }
  
  .welcome-line {
    display: contents; /* so the spans share the grid */
  }
  
  .welcome-left {
    font-weight: 100;
    text-align: right;
    padding-right: 0.25em;
  }
  
  .welcome-center {
    text-align: center;
    font-weight: 700;
  }
  
  .welcome-right {
    font-weight: 100;
    text-align: left;
    padding-left: 0.25em;
  }

  .welcome-superheader {
    text-align: center;
    font-weight: 400;
    margin-top: 0;
    margin-bottom: 0;
  }

  .welcome-header {
    text-align: center;
    font-weight: 600;
    margin-bottom: 0;
    margin-top: 0rem;
  }

  .welcome-button-text {
    width: 70%;
    text-align: center;
  }

  .welcome-modal-container {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    gap: 1.2rem;
  }

  .welcome-header {
    font-weight: 700;
  }

  .pyramid-row {
    display: flex;;
    flex-direction: row;;
    justify-content: center;
  }

  .pyramid-logo {
    width: 165px;
    margin: 8px auto;
  }

  .pyramid-row:nth-child(1) .pyramid-cell {
    background-color: var(--pyramid-logo-first-row);
  }

  .pyramid-row:nth-child(2) .pyramid-cell {
    background-color: var(--pyramid-logo-second-row);
  }

  .pyramid-row:nth-child(3) .pyramid-cell{
    background-color: var(--pyramid-logo-third-row);
  }

  .pyramid-cell {
    width: 1.5rem;
    height: 1.5rem;
    border: 4px solid var(--pyramid-logo-border);
    margin-left: -4px;
    margin-top: -4px;
    border-collapse: collapse;
  }

  .privacy-policy-settings-container {
    display: flex;
    flex-direction: row;
    gap: 0.5rem;
    align-items: center;
  }

  .privacy-policy-settings-explanation {
    color: gray;
    margin: auto;
    font-style: italic;
    margin-left: 0.5rem;
  }

  .privacy-policy-settings-header {
    margin-top: 0.6rem;
  }


  .tutorial-bypass-text {
    text-align: center;
    text-wrap: balance;
    font-size: 1.1rem;
    margin-top: -5px
  }

  .notification-time-input {
    font-size: 1.2rem;
    height: 3rem;
    font-family: 'Quicksand';
    padding: 0 5px;
  }

  .notification-time-form-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 1.8rem;
  }

  .notification-confirm-button {
    padding: 0.5rem 3rem;
    width: 5rem;
  }

  input.notification-time-input {
    background: var(--body-background-color);
    color: var(--default-text-color);
    border: 2px solid var(--default-text-color);
    font-weight: 500;
    width: fit-content;
    text-align: center;
    padding-inline-start: 0.4rem;
    padding-inline-end: 0.4rem;
  }

  .row {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    gap: 0.8rem;
  }

  .skip-notifications-link {
    margin-top: -1rem;
  }

  .error-modal-container {
    display: flex;
    flex-direction: column;
    height: calc(100% - var(--banner-height));
    justify-content: center;
    padding: 50px;
    font-size: 1.2rem;
    text-align: center;
  }

  .loading-container {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .diagnostic-info-header {
    font-size: 1.1rem;
    color: gray;
    margin: 0.25rem 0;
  }

  .diagnostic-info {
    font-size: 0.75rem;
    color: gray;
    font-style: italic;
    margin-left: 0.5rem;
  }

svg.sync-issues-icon {
    fill: #F57C00;
}

.app-store-button {
    margin: 0 auto;
    width: fit-content;
    display: block;
    fill: black; /* Force the fill to be black in any mode. */
}

.features-list {
    padding-left: 0.5rem;
}

.features-list li {
    margin-bottom: 0.5rem;
    margin-top: 0.5rem;
    list-style: none;
    display: flex;
    flex-direction: row;
    gap: 0.5rem;
}

.app-store-cta {
    font-size: 1.05rem;
}

.app-download-text {
    display: block;
    margin-top: 0.5rem;
    font-size: 1.1rem;
    font-weight: 600;
}

.badge-legend-modal h4 {
    margin-bottom: 0.5rem;
}

.sign-in-button {
    width: 6rem;
}

.sign-in-button:disabled {
    filter: opacity(0.3);
}

.vertical-flex-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 2rem;
}

.vertical-flex-container > * {
    flex: 0 0 auto;
    margin: 0;
}

.sign-in-modal {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 2rem;
}

.sign-in-modal > * {
    flex: 0 0 auto;
    margin: 0;
}


.email-input {
    height: 1.5rem;
    width: 100%;
    font-family: var(--main-font);
    font-size: 1rem;
}

.verification-modal {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1.5rem;
}

.verification-modal > * {
    flex: 0 0 auto;
    margin: 0;
}

.verification-input {
    height: 1.5rem;
    width: 100%;
    font-family: var(--main-font);
    font-size: 1rem;
}

.verify-button {
    width: 6rem;
}


.sign-in-email-label {
    font-size: 0.8rem;
}

.signed-in-as {
    display: flex;
    flex-direction: row;
    gap: 0.5rem;
    justify-content: start;
    align-items: center;
}

.login-info-container {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    align-items: start;
}

.payment-tier-badge {
    padding: 0.5rem;
    border-radius: 10rem;
    height: 1.5rem;
    width: auto;
    display: block;
    color: white;
}

.payment-tier-badge.payment-tier-badge-pro {
    background-color: gold;

}

.payment-tier-badge.payment-tier-badge-free {
    background-color: blue;
}

.login-info-container {
    font-size: 1rem;
}

.fit-content-width-button {
    width: fit-content;
    padding: 0 1rem;
}

.linkish-button {
    background: none;
    border: none;
    color: var(--default-text-color);
    padding: 0;
    cursor: pointer;
    text-decoration: underline;
    font-family: var(--main-font);
    font-size: 1.1rem;
}

.privacy-options-button-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.privacy-options-button {
    padding: 15px;
    border-radius: 25px;
}`, "",{"version":3,"sources":["webpack://./src/Game.css"],"names":[],"mappings":"AAAA;IACI,wCAAwC;IACxC,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;EACE,4BAA4B,EAAE,0BAA0B;EACxD,0BAA0B,EAAE,oCAAoC;AAClE;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,6BAA6B;IAC7B,SAAS;IACT,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,wBAAwB;IACxB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,wBAAwB;AAC5B;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;;;AAGA;IACI,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,qBAAqB;IACrB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,UAAU;IACV,iBAAiB;IACjB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,OAAO;IACP,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,WAAW;IACX,iBAAiB;IACjB,6BAA6B;IAC7B,uBAAuB;IACvB,mBAAmB;IACnB,2CAA2C;AAC/C;;AAEA;IACI,uBAAuB;IACvB,wBAAwB;IACxB,YAAY;AAChB;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,MAAM;IACN,kBAAkB;IAClB,UAAU;IACV,cAAc;IACd,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,4CAA4C;IAC5C;AACJ;;AAEA;IACI,kCAAkC;IAClC,sBAAsB;IACtB,iBAAiB;IACjB,oCAAoC;IACpC,oCAAoC;IACpC,kBAAkB;IAClB,mEAAmE;AACvE;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,mBAAmB;AACvB;;;AAGA;IACI;QACI,wBAAwB;IAC5B;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI,qBAAqB;IACrB,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;AACtB;AACA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,4BAA4B;IAC5B,kDAAkD;IAClD,wCAAwC;;AAE5C;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,6BAA6B;IAC7B,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,yCAAyC;IACzC,sBAAsB;IACtB,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,6BAA6B;IAC7B,gCAAgC;IAChC,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,WAAW;IACX,+BAA+B;AACnC;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,2BAA2B;IAC3B,6BAA6B;IAC7B,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,wBAAwB,GAAG,0BAA0B;IACrD,qBAAqB,GAAG,YAAY;AACxC;;AAEA,gDAAgD;AAChD;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,cAAc;IACd,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,cAAc;AAClB;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,6BAA6B;IAC7B,8BAA8B;AAClC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,wCAAwC,GAAG,0BAA0B;IACrE,gCAAgC,WAAW,aAAa;AAC5D;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI;QACI,UAAU;QACV,mBAAmB;IACvB;;IAEA;QACI,UAAU;QACV,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,UAAU;QACV,mBAAmB;IACvB;;IAEA;QACI,UAAU;QACV,iBAAiB;IACrB;AACJ;;AAEA;IACI,UAAU;IACV,oBAAoB;IACpB,sCAAsC;IACtC,oBAAoB;;AAExB;;AAEA;IACI,UAAU;IACV,oBAAoB;IACpB,qCAAqC;IACrC,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,4CAA4C;IAC5C,eAAe;IACf,2BAA2B;IAC3B,cAAc;IACd,aAAa;IACb,eAAe;IACf,6CAA6C;IAC7C,gBAAgB;IAChB,2JAA2J;AAC/J;;AAEA;IACI,sCAAsC;IACtC,mCAAmC;IACnC,iCAAiC;AACrC;;AAEA;IACI,yCAAyC;AAC7C;AACA;IACI,sCAAsC;AAC1C;AACA;IACI,6BAA6B;AACjC;AACA;IACI,qCAAqC;AACzC;;AAEA;IACI,0CAA0C;AAC9C;AACA;IACI,uCAAuC;AAC3C;AACA;IACI,8BAA8B;AAClC;AACA;IACI,sCAAsC;AAC1C;;AAEA;IACI,yCAAyC;AAC7C;AACA;IACI,sCAAsC;AAC1C;AACA;IACI,6BAA6B;AACjC;AACA;IACI,qCAAqC;AACzC;;AAEA;IACI,0CAA0C;AAC9C;AACA;IACI,uCAAuC;AAC3C;AACA;IACI,8BAA8B;AAClC;AACA;IACI,sCAAsC;AAC1C;;AAEA;;IAEI,yCAAyC;AAC7C;AACA;IACI,sCAAsC;AAC1C;AACA;IACI,6BAA6B;AACjC;AACA;IACI,qCAAqC;AACzC;;AAEA;IACI,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,qEAAqE;IACrE,oDAAoD;IACpD,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,qDAAqD;IACrD,2BAA2B;IAC3B,yBAAyB;IACzB,8BAA8B;IAC9B,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,wBAAwB,GAAG,0BAA0B;IACrD,qBAAqB,GAAG,YAAY;AACxC;;AAEA,gDAAgD;AAChD;IACI,aAAa;AACjB;;AAEA;IACI,MAAM;AACV;;;AAGA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,6BAA6B;IAC7B,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,gCAAgC;AACpC;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,eAAe;;AAEnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;;AAEpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,wCAAwC;AAC5C;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,aAAa;IACb,OAAO;IACP,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;IACvB,uBAAuB;IACvB,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;IACjB,OAAO;IACP,iBAAiB;AACrB;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,2BAA2B;IAC3B,OAAO;IACP,QAAQ;AACZ;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,kDAAkD;IAClD,uCAAuC;AAC3C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,wBAAwB;IACxB,yBAAyB;IACzB,WAAW;IACX,2BAA2B;IAC3B,0BAA0B;IAC1B,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,gCAAgC;IAChC,cAAc;IACd,oBAAoB;IACpB,gBAAgB;AACpB;;;AAGA;IACI,wDAAwD;IACxD,uCAAuC;AAC3C;;AAEA;IACI,WAAW;IACX,WAAW;IACX,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;AACrB;;;AAGA;;uDAEuD;;AAEvD;IACI,6BAA6B;IAC7B,0BAA0B;AAC9B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,sBAAsB;AAC1B;;AAEA;;IAEI,iBAAiB;AACrB;;;AAGA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA;;;;;yBAKyB;AACzB;IACI;QACI,aAAa;QACb,eAAe;QACf,YAAY;QACZ,WAAW;QACX,uBAAuB;QACvB,mBAAmB;QACnB,UAAU;QACV,8CAA8C;IAClD;AACJ;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,SAAS;IACT,qCAAqC;IACrC,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,qBAAqB;IACrB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,yCAAyC;IACzC,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,eAAe;;AAEnB;;AAEA;IACI,mBAAmB;IACnB,eAAe;;AAEnB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,aAAa;IACb,WAAW;IACX,YAAY;IACZ,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,uBAAuB;IACvB,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,4CAA4C;IAC5C,cAAc;IACd,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;IAC3B,yBAAyB;AAC7B;;AAEA;;;;;;;;;KASK;;AAEL;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,UAAU;IACV,QAAQ;IACR,UAAU;IACV,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,4CAA4C;IAC5C,UAAU;IACV,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,WAAW;IACX,wBAAwB;IACxB,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,cAAc;IACd,2CAA2C;IAC3C,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,2CAA2C;IAC3C,gCAAgC;AACpC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,qCAAqC;IACrC,gBAAgB;EAClB;;EAEA;IACE,iBAAiB,EAAE,gCAAgC;EACrD;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,+CAA+C;EACjD;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,+CAA+C;EACjD;;EAEA;IACE,aAAa;IACb,cAAc;IACd,4CAA4C;IAC5C,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;;EAGA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB;EACF;;EAEA;IACE,iBAAiB;IACjB,YAAY;IACZ,wBAAwB;IACxB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,oBAAoB;IACpB,WAAW;EACb;;EAEA;IACE,wCAAwC;IACxC,gCAAgC;IAChC,2CAA2C;IAC3C,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,4BAA4B;IAC5B,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,yCAAyC;IACzC,uBAAuB;IACvB,aAAa;IACb,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,mBAAmB;EACrB;;AAEF;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,WAAW,EAAE,4CAA4C;AAC7D;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,cAAc;IACd,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,cAAc;IACd,SAAS;AACb;;;AAGA;IACI,cAAc;IACd,WAAW;IACX,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,SAAS;AACb;;AAEA;IACI,cAAc;IACd,WAAW;IACX,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;;AAGA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,oBAAoB;IACpB,cAAc;IACd,WAAW;IACX,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,sBAAsB;;AAE1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,gCAAgC;IAChC,UAAU;IACV,eAAe;IACf,0BAA0B;IAC1B,6BAA6B;IAC7B,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB","sourcesContent":[".ReactModal__Content {\n    background: var(--body-background-color);\n    color: var(--default-text-color);\n}\n\nh2 {\n    font-weight: 600;\n    text-align: center;\n    font-size: 1.5rem;\n}\n\n.help-modal {\n    font-family: var(--main-font);\n    font-size: 1rem;\n}\n\n.help-modal ul {\n    padding-inline-start: 1rem;\n}\n\n.help-modal ul ol {\n  list-style-type: lower-alpha; /* Sub-list uses letters */\n  padding-inline-start: 2rem; /* Adjust indentation for sub-list */\n}\n\n.help-modal h2 {\n    margin-top: 0;\n}\n\n.help-modal li {\n    margin-bottom: 0.75rem;\n}\n\n.help-modal h4,h3, label {\n    font-size: 1.1rem;\n    font-weight: 550;\n}\n\n.help-modal code {\n    font-family: monospace;\n}\n\n.help-modal .example-container {\n    flex-direction: row;\n    display: flex;\n    justify-content: space-around;\n    gap: 1rem;\n    box-sizing: border-box;\n}\n\n.help-modal .example-triplit {\n    text-align: center;\n    margin-bottom: 0;\n}\n\n.help-modal .example-container h4 {\n    margin: 1rem;\n}\n\n.help-modal .feedback-example {\n    width: 200px;\n}\n\n.inline-square {\n    display: inline-block;\n    vertical-align: baseline;\n    width: 10px;\n    aspect-ratio: 1.0;\n}\n\n.example-blue {\n    color: #2196f3;\n}\n\n.example-green {\n    color: #4caf50;\n}\n\n.example-red {\n    color: #9c27b0;\n}\n\n.emphasized {\n    font-weight: 600;\n}\n\n.victory-modal-container {\n    font-family: var(--main-font);\n    font-size: 1.25rem;\n    text-align: center;\n    overflow-y: scroll;\n    overflow-x: hidden;\n    margin: 0 10px;\n}\n\n.victory-modal-container h2 {\n    font-size: 2rem;\n    font-weight: 590;\n    margin-top: 0.75rem;\n    margin-bottom: 0.75rem;\n}\n\n.victory-modal-container .percentile-text {\n    font-size: 0.9rem;\n}\n\n.victory-modal-container .score-explanation-icon {\n    width: 1rem;\n    fill: rgb(125, 125, 125);\n}\n\n.victory-modal-container .medal-img {\n    width: 75%;\n    height: auto;\n}\n\n\n.victory-modal-container h3 {\n    text-align: start;\n    margin-bottom: 0.75rem;\n}\n\n.victory-modal-container .statistics-section {\n    font-size: 1rem;\n}\n\n.victory-modal-container .statistics-section tr:nth-child(1) {\n    font-weight: 600;\n    font-size: 1.2rem;\n}\n\n.victory-buttons-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-top: 1.25rem;\n    margin-bottom: 0.8rem;\n    justify-content: center;\n    gap: 0.4rem;\n}\n\n.game-button.victory-button {\n    font-size: 1.2rem;\n    font-weight: 600;\n    flex-direction: row;\n    width: 75%;\n    padding: 0.5rem 0;\n    gap: 0.25rem;\n    border-radius: 10px;\n}\n\ntd.statistics-container {\n    vertical-align: center;\n}\n\n.game-button {\n    display: flex;\n    flex: 1;\n    flex-direction: column;\n    border-radius: 10px;\n    color: white;\n    fill: white;\n    border: 0px;\n    font-size: 1.1rem;\n    font-family: var(--main-font);\n    justify-content: center;\n    align-items: center;\n    background-color: var(--victory-modal-gray);\n}\n\nbutton.button-secondary {\n    background-color: white;\n    outline: 1px solid black;\n    color: black;\n}\n\n.share-button-default {\n    background-color: var(--victory-modal-gray);\n}\n\ntd.statistics-container {\n    width: 5%;\n    min-width: 3rem;\n}\n\n.no-break {\n    white-space: nowrap;\n}\n\n.tutorial-exit-button {\n    top: 0;\n    position: absolute;\n    left: 0rem;\n    margin: 0.5rem;\n    fill: rgb(150, 150, 150);\n}\n\n.turn-indicator-container {\n    position: absolute;\n    top: 0;\n    right: 0;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    gap: calc(var(--turn-indicator-width) * 0.3);\n    margin: 0.75rem var(--turn-indicator-width)\n}\n\n.turn-indicator {\n    width: var(--turn-indicator-width);\n    box-sizing: border-box;\n    aspect-ratio: 1.0;\n    border: 1px solid rgb(200, 200, 200);\n    background-color: rgb(200, 200, 200);\n    border-radius: 50%;\n    transition: background-color var(--turn-transition-duration) linear;\n}\n\n.turn-indicator.turn-indicator-empty {\n    background-color: transparent;\n}\n\n.special-modal-container {\n    font-family: var(--main-font);\n    font-size: 1.25rem;\n    text-align: center;\n    overflow-y: scroll;\n    overflow-x: hidden;\n    margin: 0 10px;\n    height: fit-content;\n}\n\n\n@keyframes shakeHeadNo {\n    0% {\n        transform: translateX(0);\n    }\n\n    25% {\n        transform: translateX(-1.2rem);\n    }\n\n    50% {\n        transform: translateX(0);\n    }\n\n    75% {\n        transform: translateX(1.2rem);\n    }\n\n    100% {\n        transform: translateX(0);\n    }\n}\n\n@keyframes victoryAnimation {\n    0% {\n        transform: scale(1);\n    }\n\n    7% {\n        transform: scale(1.10);\n    }\n\n    14% {\n        transform: scale(1.05);\n    }\n\n    21% {\n        transform: scale(1.10);\n    }\n\n    60% {\n        transform: scale(1.10);\n    }\n\n    100% {\n        transform: scale(1);\n    }\n}\n\n.victory-animation {\n    display: inline-block;\n    animation: victoryAnimation 1s linear;\n}\n\n.center-text {\n    text-align: center;\n}\na.game-link {\n    text-decoration: none;\n    color: inherit;\n}\n\n.banner-top {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    height: var(--banner-height);\n    box-shadow: 0px 2px 4px var(--banner-shadow-color);\n    /* border-bottom: 1px solid lightgray; */\n\n}\n\nhtml[data-theme='dark'] .banner-top {\n    box-shadow: 0px 2px 2px var(--banner-shadow-color);\n}\n\n.outer-container {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: center;\n    font-size: 1.5rem;\n    font-family: var(--main-font);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    overflow: hidden;\n}\n\n.inner-container {\n    display: flex;\n    width: 100%;\n    height: calc(100% - var(--banner-height));\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: center;\n    overflow: hidden;\n    position: relative;\n}\n\n.game-title {\n    font-size: 2rem;\n    font-family: var(--main-font);\n    color: var(--default-text-color);\n    margin-left: 0.5rem;\n    font-weight: 500;\n}\n\n.menu-buttons-container {\n    margin-right: 0.5rem;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n    gap: 0.25rem;\n    fill: rgb(100, 100, 100);\n}\n\n.menu-buttons-container svg {\n    height: 50%;\n    width: auto;\n    fill: var(--default-text-color);\n}\n\n.game-container {\n    font-size: 1.5rem;\n    width: 100%;\n    min-width: 10rem;\n    max-width: var(--max-width);\n    font-family: var(--main-font);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    flex: 3 1 70%;\n    min-height: 0;\n    overflow-x: hidden;\n    overflow-y: scroll;\n    justify-content: space-around;\n}\n\n.game-container {\n    -ms-overflow-style: none;  /* Internet Explorer 10+ */\n    scrollbar-width: none;  /* Firefox */\n}\n\n/* Hide scrollbar for Chrome, Safari and Opera */\n.game-container::-webkit-scrollbar {\n    display: none;\n}\n\n.guess-row {\n    display: flex;\n    flex-direction: row;\n    flex-grow: 1;\n    flex-shrink: 1;\n    flex-basis: 0;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    margin: 0 auto;\n}\n\n.guess-row:nth-of-type(1) {\n    width: 37.5%\n}\n\n.guess-row:nth-of-type(2) {\n    width: 50%\n}\n\n.guess-row:nth-of-type(3) {\n    width: 62.5%;\n}\n\n.guess-row:nth-of-type(4) {\n    width: 75%;\n}\n\n.control-row {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 2rem;\n}\n\n.input-box {\n    text-transform: uppercase;\n    width: 1rem;\n    height: 1rem;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    font-size: 50cqw;\n}\n\n.input-box.filled-in-by-user {\n    color: var(--default-text-color);\n}\n\n.input-box.input-failed {\n    color: var(--default-text-color);\n}\n\n.input-box.input-incorrect {\n    color: var(--incorrect-color);\n    transition: color 500ms linear;\n}\n\n.input-box.triplet-box {\n    color: var(--default-text-color);\n}\n\n.input-container.triplet-letter-container {\n    outline: none;\n    font-weight: 600;\n    -webkit-tap-highlight-color: transparent;  /* For Safari and Chrome */\n    tap-highlight-color: transparent;          /* Standard */\n}\n\n.input-container.triplet-letter-container.triplet-blur {\n    visibility: hidden;\n}\n\n@keyframes fadeIn {\n    0% {\n        opacity: 0;\n        /* Starting state */\n    }\n\n    100% {\n        opacity: 1;\n        /* Ending state */\n    }\n}\n\n@keyframes fadeOut {\n    0% {\n        opacity: 1;\n        /* Starting state */\n    }\n\n    100% {\n        opacity: 0;\n        /* Ending state */\n    }\n}\n\n.fade-out {\n    opacity: 1;\n    /* Start invisible */\n    animation: fadeOut 1s ease-in forwards;\n    /* Apply animation */\n\n}\n\n.fade-in {\n    opacity: 0;\n    /* Start invisible */\n    animation: fadeIn 1s ease-in forwards;\n    /* Apply animation */\n}\n\n.input-container {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    outline: 2px solid var(--cell-outline-color);\n    aspect-ratio: 1;\n    container-type: inline-size;\n    flex: 0 1 auto;\n    width: 18vmin;\n    max-width: 5rem;\n    margin: calc(var(--letter-margin-rem) * 1rem);\n    font-weight: 600;\n    transition: color var(--half-turn-transition-duration) var(--half-turn-transition-duration) linear, background-color var(--turn-transition-duration) linear;\n}\n\n.tile-verified {\n    background-color: var(--verified-blue);\n    outline-color: var(--verified-blue);\n    color: var(--verified-text-color);\n}\n\n.game-button.first-turn, .histogram-bar.first-turn, .first-turn {\n    background-color: var(--first-turn-color);\n}\n.first-turn-outline {\n    outline-color: var(--first-turn-color);\n}\n.clue-checkmark-container.first-turn-fill, .first-turn-fill {\n    fill: var(--first-turn-color);\n}\n.first-turn-border {\n    border-color: var(--first-turn-color);\n}\n\n.game-button.second-turn, .histogram-bar.second-turn, .second-turn {\n    background-color: var(--second-turn-color);\n}\n.second-turn-outline {\n    outline-color: var(--second-turn-color);\n}\n.clue-checkmark-container.second-turn-fill, .second-turn-fill {\n    fill: var(--second-turn-color);\n}\n.second-turn-border {\n    border-color: var(--second-turn-color);\n}\n\n.game-button.third-turn, .histogram-bar.third-turn, .third-turn {\n    background-color: var(--third-turn-color);\n}\n.third-turn-outline {\n    outline-color: var(--third-turn-color);\n}\n.clue-checkmark-container.third-turn-fill, .third-turn-fill {\n    fill: var(--third-turn-color);\n}\n.third-turn-border {\n    border-color: var(--third-turn-color);\n}\n\n.game-button.fourth-turn, .histogram-bar.fourth-turn, .fourth-turn {\n    background-color: var(--fourth-turn-color);\n}\n.fourth-turn-outline {\n    outline-color: var(--fourth-turn-color);\n}\n.clue-checkmark-container.fourth-turn-fill, .fourth-turn-fill {\n    fill: var(--fourth-turn-color);\n}\n.fourth-turn-border {\n    border-color: var(--fourth-turn-color);\n}\n\nbutton.fifth-turn, .histogram-bar.fifth-turn, .fifth-turn {\n\n    background-color: var(--fifth-turn-color);\n}\n.fifth-turn-outline {\n    outline-color: var(--fifth-turn-color);\n}\n.clue-checkmark-container.fifth-turn-fill, .fifth-turn-fill {\n    fill: var(--fifth-turn-color);\n}\n.fifth-turn-border {\n    border-color: var(--fifth-turn-color);\n}\n\n.clue-checkmark-container {\n    display: contents;\n    fill: var(--verified-blue);\n}\n\n.clue-checkmark-container.clue-checkmark-hidden {\n    opacity: 0;\n}\n\n.clue-checkmark {\n    opacity: inherit;\n    fill: inherit;\n    transform: translateY(5%);\n    transition: opacity calc(var(--turn-transition-duration)) 0.1s linear;\n    width: max(0.5rem, min(min(5.2cqw, 3.5cqh), 1.8rem));\n    display: block;\n    flex: 0 0 auto;\n}\n\n.outer-clue-container {\n    flex: 0 1 auto;\n    width: 100%;\n}\n\n.clue-reminder .clue-container {\n    font-size: 2.5vh;\n    text-wrap: balance;\n}\n\n.clue-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    width: 100%;\n    font-size: clamp(0.5rem, min(5.2cqw, 3.5cqh), 1.8rem);\n    container-type: inline-size;\n    height: min(20vmin, 15vh);\n    font-family: var(--title-font);\n    overflow-y: scroll;\n    gap: 0.25rem;\n}\n\n.reminder-middle {\n    font-style: italic;\n}\n\n.clue-container {\n    -ms-overflow-style: none;  /* Internet Explorer 10+ */\n    scrollbar-width: none;  /* Firefox */\n}\n\n/* Hide scrollbar for Chrome, Safari and Opera */\n.clue-container::-webkit-scrollbar {\n    display: none;\n}\n\n.clue-container.clue-container-no-checkmark {\n    gap: 0;\n}\n\n\n@media screen and (max-height: 650px) {\n    .input-container {\n        width: 8vh;\n    }\n}\n\n.guesses-container {\n    display: flex;\n    flex-direction: column;\n    flex: 0 1 auto;\n    max-width: 45rem;\n}\n\n.first-row-no-triplit {\n    margin-top: 4vh;\n}\n\n.input-container.selected { \n    outline: 2px solid var(--selected-color);\n}\n\n.timer-container {\n    overflow: visible;\n    margin: 0 0.5rem;\n    text-align: left;\n}\n\n.timer {\n    font-size: 1.25rem;\n    font-weight: 500;\n    margin-top: 0.1rem;\n    margin-right: 0.1rem;\n}\n\n.banner-icon-container {\n    display: flex;\n}\n\n.banner-icon {\n    fill: var(--default-text-color);\n}\n\n.streak-container {\n    display: flex;\n    flex-direction: row;\n    font-size: 1.4rem;\n    align-items: center;\n    font-weight: 600;\n    color: rgb(var(--streak-color));\n}\n\n.menu-buttons-container .streak-container .flame-icon {\n    fill: rgb(var(--streak-color));\n}\n\n.streak-text {\n    font-weight: 600;\n    color: rgb(var(--streak-color));\n}\n\n.flame-icon {\n    margin-left: -0.1rem;\n}\n\n#help-icon {\n    width: 1.5rem;\n    height: 1.5rem;\n}\n\n.hamburger-menu-container {\n    font-family: var(--main-font);\n    font-size: 1.2rem;\n}\n\n.hamburger-menu-item a {\n    text-decoration: none;;\n    color: var(--default-text-color);\n}\n\n.hamburger-menu-item:not(:last-child) {\n    border-bottom: 1px solid var(--default-text-color);\n}\n\n.hamburger-menu-item {\n    padding-top: 0.4rem;\n    padding-bottom: 0.4rem;\n    padding-left: 0.4rem;\n    padding-right: 0.4rem;\n}\n\n.date-selector-modal-container {\n    font-family: var(--main-font);\n    font-size: 1.25rem;\n    margin: 0.5rem;\n}\n\n.settings-modal-container {\n    font-family: var(--main-font);\n    font-size: 1.25rem;\n    display: flex;\n    flex-direction: column;\n    gap: 1.25rem;\n}\n\n.settings-modal-container * {\n    margin-top: 0;\n    margin-bottom: 0;\n}\n\n.settings-section {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n}\n\n.notification-time-label {\n    font-size: 1rem;\n\n}\n\n.settings-modal-container .notification-time-input {\n    border-width: 1px;\n}\n\n.settings-modal-container table {\n    width: 100%;\n    border-collapse: collapse;\n}\n\n.settings-modal-container h2 {\n    text-align: center;\n    font-size: 1.5rem;\n}\n\n.settings-modal-container tr:not(:last-child) td {\n    padding-bottom: 0.5rem;\n}\n\n.settings-modal-container td:nth-child(1) {\n    text-align: left;\n    padding-left: 1.5rem;\n}\n\n.settings-modal-container td:nth-child(2) {\n    text-align: right;\n    padding-right: 1.5rem;\n}\n\n.settings-modal-container b {\n    font-weight: 600;\n\n}\n\n.settings-modal-container h2 {\n    font-weight: 600;\n}\n\n.settings-modal-container input {\n    -webkit-tap-highlight-color: transparent;\n}\n\n\n.timer-setting-container {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.timer-slider-container {\n    height: 1.5rem;\n}\n\n.timer-slider {\n    width: 100%;\n}\n\n.timer-setting-label {\n    font-size: 1rem;\n    text-align: center;\n    height: 0;\n}\n\n.adjustment-text {\n    font-size: 1rem;\n    margin-top: 0.75rem;\n}\n\n.adjustment-text-link {\n    text-decoration: underline;\n    cursor: pointer;\n}\n\n.difficulty-list {\n    font-size: 1rem;\n    padding: 0;\n}\n\n.difficulty-settings-container {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    margin: auto;\n    width: 85%;\n}\n\n.difficulty-setting-container {\n    display: flex;\n    flex: 1;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 0.5rem;\n}\n\n.difficulty-setting-container input[type=\"radio\"] {\n    box-sizing: border-box;\n    appearance: none;\n    background: white;\n    outline: 1px solid #333;\n    border: 3px solid white;\n    border-radius: 0;\n    width: 1.25rem;\n    height: 1.25rem;\n}\n\n.difficulty-setting-container input[type=\"radio\"]:checked {\n    background-color: var(--selection-blue);\n}\n\n.difficulty-setting-container label {\n    font-size: 1.1rem;\n}\n\n.settings-modal-container ul {\n    list-style-position: inside;\n}\n\n.difficulty-slider {\n    width: 100%;\n}\n\n.difficulty-slider-labels {\n    display: flex;\n    justify-content: space-between;\n}\n\n.difficulty-slider-label-container {\n    margin-top:0.5rem;\n    width:0;\n    overflow: visible;\n}\n\n.difficulty-slider-label {\n    transform: translateX(-50%);\n    width: fit-content;\n    font-size: 1rem;\n}\n\n.setting-explanation {\n    font-size: 1rem;\n    color: rgb(75, 75, 75);\n}\n\n.keyboard-container {\n    flex: 1 0 30%;\n    max-height: 13rem;\n    font-size: 1.25rem;\n    width: 100%;\n    max-width: var(--max-width);\n    left: 0;\n    right: 0;\n}\n\n.keyboard-container .hg-theme-default .hg-button {\n    border-bottom: none;\n    box-shadow: none;\n    background: var(--default-button-background-color);\n    color: var(--default-button-text-color);\n}\n\n.keyboard-container .react-simple-keyboard {\n    width: 100%;\n    height: 100%;\n    max-height: 15rem;\n    background-color: initial;\n    font-weight: 500;\n}\n\n.keyboard-container .react-simple-keyboard .hg-rows {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n}\n\n.keyboard-container .react-simple-keyboard .hg-rows .hg-row {\n    flex-grow: 1;\n}\n\n.control-row {\n    fill: rgb(100, 100, 100);\n    color: rgb(100, 100, 100);\n    width: 100%;\n    container-type: inline-size;\n    height: calc(3.5rem + 4vh);\n    max-height: 5rem;\n    flex: 0 1 auto;\n}\n\n.control-row button {\n    width: 7.5rem;\n    height: 60%;\n    color: var(--default-text-color);\n    flex: 0 0 auto;\n    border-radius: 10cqw;\n    font-weight: 500;\n}\n\n\n.control-row button.action-button {\n    background-color: var(--default-button-background-color);\n    color: var(--default-button-text-color);\n}\n\n.control-row .icon {\n    height: 50%;\n    width: auto;\n    fill: inherit;\n    flex: 0 0 auto;\n}\n\n.control-row button:disabled {\n    filter: opacity(0.3);\n}\n\n.control-row svg.icon path {\n    stroke-width: 1px;\n}\n\n\n/** Note that all of the CSS rules related to the keyboard must be highly\n  * sepcified in order to have higher precedence than the rules built into\n  * the default theme of the simple-keyboard library. */\n\n.keyboard-container .custom-keyboard-theme {\n    font-family: var(--main-font);\n    text-transform: capitalize;\n}\n\n.keyboard-container .custom-keyboard-theme .hg-button {\n    height: 100%;\n}\n\n.keyboard-container .custom-keyboard-theme .hg-button.hg-standardBtn {\n    width: 8.5%;\n    flex-grow: 0;\n}   \n\n.keyboard-container .custom-keyboard-theme .hg-button.hg-functionBtn {\n    width: 13%;\n    flex-grow: 0;\n}   \n\n.keyboard-container .custom-keyboard-theme .hg-button.hg-button-backspace {\n    width: 13%;\n    font-family: system-ui;\n}   \n\n.keyboard-container .custom-keyboard-theme .hg-button.hg-button-clear,\n.keyboard-container .custom-keyboard-theme .hg-button.hg-button-enter {\n    font-size: 0.8rem;\n}   \n\n\n.keyboard-container .custom-keyboard-theme .hg-row {\n    justify-content: center;\n}\n\n.mobile-landscape-warning-container {\n    display: none;\n}\n\n/* There is no way to specifically query for mobile devices - there are only proxies.\n    For now we will use the height of the viewport and the orientation to detect if a user\n    is on a mobile device using portrait mode. When the orientation lock API is more widely\n    supported, we can use that instead. For now this query will also pick up users on\n    desktops/laptops who have their browser window very small and wide. This seems\n    acceptable for now. */\n@media only screen and (max-height: 480px) and (orientation: landscape) {\n    .mobile-landscape-warning-container {\n        display: flex;\n        position: fixed;\n        height: 100%;\n        width: 100%;\n        justify-content: center;\n        align-items: center;\n        opacity: 1;\n        background-color: var(--body-background-color);\n    }\n}\n\n.banner-popup {\n    position: absolute;\n    margin: 0 auto;\n    top: 0.5%;\n    max-width: min(var(--max-width), 80%);\n    height: fit-content;\n    background-color: #4f4f4f;\n    color: white;\n    opacity: 95%;\n    padding: 1rem;\n    border-radius: 0.5rem;\n    font-size: 1.1rem;\n    font-weight: 500;\n    text-align: center;\n    z-index: 10000;\n}\n\n.gameplay-video {\n    width: 90%;\n    height: auto;\n    max-width: 375px;\n    margin: 0 auto;\n    display: block;\n}\n\n.gameplay-video-container {\n    margin: 0 auto;\n    width: fit-content;\n}\n\n.congrats-header {\n    font-size: 1.25rem;\n}\n\n.play-button-container {\n    margin: 0 auto;\n    width: fit-content;\n}\n\n.play-button {\n    height: 3rem;\n    width: 4rem;\n    border-radius: 2rem;\n    background-color: var(--first-turn-color);\n    font-weight: 600;\n}\n\n.examples-modal table {\n    border-collapse: collapse;\n}\n\n.examples-modal {\n    font-size: 0.9rem;\n}\n\n.examples-modal td {\n    vertical-align: top;\n    padding: 0.5rem;\n\n}\n\n.examples-modal td {\n    vertical-align: top;\n    padding: 0.5rem;\n\n}\n\n.examples-modal h3 {\n    margin-top: 0.125rem;\n}\n\n.examples-modal tbody>tr:nth-of-type(odd) {\n    background-color: var(--lighter-table-row-color);\n}\n\n.examples-modal td, .examples-modal th {\n    padding: 0.5rem 0.25rem;\n    text-align: left;\n}\n\n.wordplay-modal {\n    font-size: 0.9rem;\n}\n\n.disconnected-icon {\n    display: block;\n    margin: 0 auto;\n    padding: 20px;\n    width: 60px;\n    height: auto;\n    fill: var(--default-text-color);\n}\n\n.bonus-puzzles-modal-container {\n    text-align: center;\n    font-size: 1.1rem;\n}\n\n.bonus-puzzles-container {\n    display: flex;\n    flex-direction: row;\n    gap: 0.5rem;\n    flex-wrap: wrap;\n    justify-content: center;\n    width: 80%;\n    margin: 0 auto;\n}\n\n.bonus-puzzle-cell {\n    width: 1rem;\n    padding: 0.4rem;\n    outline: 1px solid var(--cell-outline-color);\n    flex: 0 0 auto;\n    display: flex;\n    justify-content: center;\n    position: relative;\n    border-radius: 2px;\n}\n\n.bonus-puzzle-cell.bonus-locked {\n    background-color: lightgray;\n    color: rgb(125, 125, 125);\n}\n\n/*\n.bonus-locked::after {\n    content: \"🔒\";\n    position: absolute;\n    font-size: 0.5rem;\n    color: lightgray;\n    top: -0.5px;\n    right: -0.5px;\n}\n    */\n\n.bonus-puzzles-modal-container h2 {\n    text-align: center;\n}\n\n.bonus-puzzles-modal-container .lock-icon {\n    position: absolute;\n    top: 0;\n    right: 0;\n    width: 0.5rem;\n}\n\n.bonus-puzzle-unseen::after {\n    content: \"\";\n    background-color: #3d88ed; \n    position: absolute;\n    display: block;\n    right: 2px;\n    top: 2px;\n    width: 7px;\n    aspect-ratio: 1.0;\n    border-radius: 50%;\n}\n\n.bonus-selected {\n    background-color: var(--selected-puzzle-color);\n}\n\n.present-icon {\n    position: relative;\n}\n\n.present-icon-container {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    position: relative;\n}\n\n.present-icon-container.unseen-bonus::after {\n    outline: 2px solid var(--default-text-color);\n    width: 2px;\n    aspect-ratio: 1.0;\n    content: \"\";\n    position: absolute;\n    display: block;\n    right: 1.5px;\n    top: -1.5px;\n    /* border-radius: 6px; */\n    transform: rotate(45deg);\n}\n\n.svg-as-text {\n    fill: white;\n    vertical-align: text-bottom;\n}\n\n.learning-style-container {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: 0.5rem;\n}\n\n.learning-style-button {\n    height: 3rem;\n    width: 6rem;\n    flex: 0 1 auto;\n    background-color: var(--start-button-color);\n    border-radius: 1rem;\n    font-weight: 700;\n    font-size: 1.3rem;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    gap: 0.3rem;\n    border: 4px solid var(--default-text-color);\n    color: var(--default-text-color);\n}\n\n.learning-style-button:hover {\n    background-color: lightgray;\n}\n\n.welcome-description-container {\n    width: fit-content;\n    margin-left: auto;\n    margin-right: auto;\n    font-size: 1.3rem;\n}\n\n.welcome-description {\n    text-align: center;\n    display: inline-grid;\n    grid-template-columns: auto auto auto;\n    margin-left: 5px;\n  }\n  \n  .welcome-line {\n    display: contents; /* so the spans share the grid */\n  }\n  \n  .welcome-left {\n    font-weight: 100;\n    text-align: right;\n    padding-right: 0.25em;\n  }\n  \n  .welcome-center {\n    text-align: center;\n    font-weight: 700;\n  }\n  \n  .welcome-right {\n    font-weight: 100;\n    text-align: left;\n    padding-left: 0.25em;\n  }\n\n  .welcome-superheader {\n    text-align: center;\n    font-weight: 400;\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n\n  .welcome-header {\n    text-align: center;\n    font-weight: 600;\n    margin-bottom: 0;\n    margin-top: 0rem;\n  }\n\n  .welcome-button-text {\n    width: 70%;\n    text-align: center;\n  }\n\n  .welcome-modal-container {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-around;\n    align-items: center;\n    gap: 1.2rem;\n  }\n\n  .welcome-header {\n    font-weight: 700;\n  }\n\n  .pyramid-row {\n    display: flex;;\n    flex-direction: row;;\n    justify-content: center;\n  }\n\n  .pyramid-logo {\n    width: 165px;\n    margin: 8px auto;\n  }\n\n  .pyramid-row:nth-child(1) .pyramid-cell {\n    background-color: var(--pyramid-logo-first-row);\n  }\n\n  .pyramid-row:nth-child(2) .pyramid-cell {\n    background-color: var(--pyramid-logo-second-row);\n  }\n\n  .pyramid-row:nth-child(3) .pyramid-cell{\n    background-color: var(--pyramid-logo-third-row);\n  }\n\n  .pyramid-cell {\n    width: 1.5rem;\n    height: 1.5rem;\n    border: 4px solid var(--pyramid-logo-border);\n    margin-left: -4px;\n    margin-top: -4px;\n    border-collapse: collapse;\n  }\n\n  .privacy-policy-settings-container {\n    display: flex;\n    flex-direction: row;\n    gap: 0.5rem;\n    align-items: center;\n  }\n\n  .privacy-policy-settings-explanation {\n    color: gray;\n    margin: auto;\n    font-style: italic;\n    margin-left: 0.5rem;\n  }\n\n  .privacy-policy-settings-header {\n    margin-top: 0.6rem;\n  }\n\n\n  .tutorial-bypass-text {\n    text-align: center;\n    text-wrap: balance;\n    font-size: 1.1rem;\n    margin-top: -5px\n  }\n\n  .notification-time-input {\n    font-size: 1.2rem;\n    height: 3rem;\n    font-family: 'Quicksand';\n    padding: 0 5px;\n  }\n\n  .notification-time-form-container {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: 1.8rem;\n  }\n\n  .notification-confirm-button {\n    padding: 0.5rem 3rem;\n    width: 5rem;\n  }\n\n  input.notification-time-input {\n    background: var(--body-background-color);\n    color: var(--default-text-color);\n    border: 2px solid var(--default-text-color);\n    font-weight: 500;\n    width: fit-content;\n    text-align: center;\n    padding-inline-start: 0.4rem;\n    padding-inline-end: 0.4rem;\n  }\n\n  .row {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    gap: 0.8rem;\n  }\n\n  .skip-notifications-link {\n    margin-top: -1rem;\n  }\n\n  .error-modal-container {\n    display: flex;\n    flex-direction: column;\n    height: calc(100% - var(--banner-height));\n    justify-content: center;\n    padding: 50px;\n    font-size: 1.2rem;\n    text-align: center;\n  }\n\n  .loading-container {\n    height: 100%;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n  }\n\n  .diagnostic-info-header {\n    font-size: 1.1rem;\n    color: gray;\n    margin: 0.25rem 0;\n  }\n\n  .diagnostic-info {\n    font-size: 0.75rem;\n    color: gray;\n    font-style: italic;\n    margin-left: 0.5rem;\n  }\n\nsvg.sync-issues-icon {\n    fill: #F57C00;\n}\n\n.app-store-button {\n    margin: 0 auto;\n    width: fit-content;\n    display: block;\n    fill: black; /* Force the fill to be black in any mode. */\n}\n\n.features-list {\n    padding-left: 0.5rem;\n}\n\n.features-list li {\n    margin-bottom: 0.5rem;\n    margin-top: 0.5rem;\n    list-style: none;\n    display: flex;\n    flex-direction: row;\n    gap: 0.5rem;\n}\n\n.app-store-cta {\n    font-size: 1.05rem;\n}\n\n.app-download-text {\n    display: block;\n    margin-top: 0.5rem;\n    font-size: 1.1rem;\n    font-weight: 600;\n}\n\n.badge-legend-modal h4 {\n    margin-bottom: 0.5rem;\n}\n\n.sign-in-button {\n    width: 6rem;\n}\n\n.sign-in-button:disabled {\n    filter: opacity(0.3);\n}\n\n.vertical-flex-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 2rem;\n}\n\n.vertical-flex-container > * {\n    flex: 0 0 auto;\n    margin: 0;\n}\n\n.sign-in-modal {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 2rem;\n}\n\n.sign-in-modal > * {\n    flex: 0 0 auto;\n    margin: 0;\n}\n\n\n.email-input {\n    height: 1.5rem;\n    width: 100%;\n    font-family: var(--main-font);\n    font-size: 1rem;\n}\n\n.verification-modal {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 1.5rem;\n}\n\n.verification-modal > * {\n    flex: 0 0 auto;\n    margin: 0;\n}\n\n.verification-input {\n    height: 1.5rem;\n    width: 100%;\n    font-family: var(--main-font);\n    font-size: 1rem;\n}\n\n.verify-button {\n    width: 6rem;\n}\n\n\n.sign-in-email-label {\n    font-size: 0.8rem;\n}\n\n.signed-in-as {\n    display: flex;\n    flex-direction: row;\n    gap: 0.5rem;\n    justify-content: start;\n    align-items: center;\n}\n\n.login-info-container {\n    display: flex;\n    flex-direction: column;\n    gap: 0.25rem;\n    align-items: start;\n}\n\n.payment-tier-badge {\n    padding: 0.5rem;\n    border-radius: 10rem;\n    height: 1.5rem;\n    width: auto;\n    display: block;\n    color: white;\n}\n\n.payment-tier-badge.payment-tier-badge-pro {\n    background-color: gold;\n\n}\n\n.payment-tier-badge.payment-tier-badge-free {\n    background-color: blue;\n}\n\n.login-info-container {\n    font-size: 1rem;\n}\n\n.fit-content-width-button {\n    width: fit-content;\n    padding: 0 1rem;\n}\n\n.linkish-button {\n    background: none;\n    border: none;\n    color: var(--default-text-color);\n    padding: 0;\n    cursor: pointer;\n    text-decoration: underline;\n    font-family: var(--main-font);\n    font-size: 1.1rem;\n}\n\n.privacy-options-button-container {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\n.privacy-options-button {\n    padding: 15px;\n    border-radius: 25px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
